var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRound42B = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 60 60",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 37,
  cy: 30,
  r: 12,
  fill: "#464D57"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#464D57",
  fillRule: "evenodd",
  d: "M36.5 13c-4.341 0-8.527 1.765-11.63 4.942C21.763 21.122 20 25.458 20 30s1.764 8.878 4.87 12.059C27.973 45.235 32.159 47 36.5 47a4.5 4.5 0 1 1 0 9c-6.798 0-13.295-2.766-18.068-7.653C13.662 43.464 11 36.862 11 30c0-6.862 2.662-13.463 7.432-18.347C23.205 6.766 29.702 4 36.5 4a4.5 4.5 0 1 1 0 9Z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#BABCC0",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M37 56a26 26 0 1 1 0-52"
})));
SvgRound42B.viewBox = '0 0 60 60';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRound42B);
export default ForwardRef;